<app-page-container maxHeight>
  <app-header [paddingBottom]="false" appTitle="Fechamento" [subTitulo]="dadosRota.codFatura">
    <div class="c-row">
      <app-botao-voltar></app-botao-voltar>
      <app-botao-incluir (click)="visualizarRelatorio()" title="Visualizar Relatório">
      </app-botao-incluir>
    </div>
    <app-botoes-files (OnClickApplyPDFButton)="getDownloadPDFFechamentos()"
      (OnClickApplyCSVButton)="getDownloadCSVFechamentos()"></app-botoes-files>
  </app-header>
  <ng-container *ngIf="fechamentos.registros.length; else listagemVaziaRef">
    <div class="c-table-container">
      <table class="c-table-container__table" mat-table [dataSource]="fechamentos.registros">
        <ng-container matColumnDef="numSerie">
          <th class="u-padding-horizontal-0" mat-header-cell *matHeaderCellDef>
            <div class="u-border-none c-table-container__table__header-text">Nº de série</div>
          </th>
          <td class="c-table-container__table__cell" mat-cell *matCellDef="let fechamento">
            {{fechamento.numSerie
            || "Sem dados"}}</td>
        </ng-container>
        <ng-container matColumnDef="marca">
          <th class="u-padding-horizontal-0" mat-header-cell *matHeaderCellDef>
            <div class="c-table-container__table__header-text">Marca</div>
          </th>
          <td class="c-table-container__table__cell" mat-cell *matCellDef="let fechamento">
            {{fechamento.nomeMarcaProduto
            || "Sem dados"}} </td>
        </ng-container>
        <ng-container matColumnDef="modelo">
          <th class="u-padding-horizontal-0" mat-header-cell *matHeaderCellDef>
            <div class="c-table-container__table__header-text">Modelo</div>
          </th>
          <td class="c-table-container__table__cell" mat-cell *matCellDef="let fechamento"> {{fechamento.nomeProduto ||
            "Sem dados"}}
          </td>
        </ng-container>
        <ng-container matColumnDef="endereco">
          <th class="u-padding-horizontal-0" mat-header-cell *matHeaderCellDef>
            <div class="c-table-container__table__header-text">Endereço</div>
          </th>
          <td class="c-table-container__table__cell" mat-cell *matCellDef="let fechamento"> {{fechamento.endereco ||
            "Sem dados"}}
          </td>
        </ng-container>
        <ng-container matColumnDef="acessorios">
          <th class="u-padding-horizontal-0" mat-header-cell *matHeaderCellDef>
            <div class="c-table-container__table__header-text">Acessórios</div>
          </th>
          <td class="c-table-container__table__cell" mat-cell *matCellDef="let fechamento"> <app-listagem-acessorios
              [codContrato]="fechamento.codContrato" [numSerie]="fechamento.numSerie"></app-listagem-acessorios>
          </td>
        </ng-container>
        <ng-container matColumnDef="anteriorPb">
          <th class="u-padding-horizontal-0" mat-header-cell *matHeaderCellDef>
            <div class="c-table-container__table__header-text">Anterior P/B</div>
          </th>
          <td class="c-table-container__table__cell" mat-cell *matCellDef="let fechamento">
            {{fechamento.medidorAnteriorLeitura || "Sem dados"
            }}
          </td>
        </ng-container>
        <ng-container matColumnDef="atualPb">
          <th class="u-padding-horizontal-0" mat-header-cell *matHeaderCellDef>
            <div class="c-table-container__table__header-text">Atual P/B</div>
          </th>
          <td class="c-table-container__table__cell" mat-cell *matCellDef="let fechamento">
            {{fechamento.medidorAtualLeitura || "Sem dados"
            }} </td>
        </ng-container>
        <ng-container matColumnDef="producaoPb">
          <th class="u-padding-horizontal-0" mat-header-cell *matHeaderCellDef>
            <div class="c-table-container__table__header-text">Produção P/B</div>
          </th>
          <td class="c-table-container__table__cell" mat-cell *matCellDef="let fechamento">
            {{fechamento.totalCopiasPBLeitura ||
            "Sem dados"}} </td>
        </ng-container>
        <ng-container matColumnDef="anteriorColor">
          <th class="u-padding-horizontal-0" mat-header-cell *matHeaderCellDef>
            <div class="c-table-container__table__header-text">Anterior color</div>
          </th>
          <td class="c-table-container__table__cell" mat-cell *matCellDef="let fechamento">
            {{fechamento.medidorAnteriorColorLeitura ||
            "Sem dados"}} </td>
        </ng-container>
        <ng-container matColumnDef="atualColor">
          <th class="u-padding-horizontal-0" mat-header-cell *matHeaderCellDef>
            <div class="c-table-container__table__header-text">Atual color</div>
          </th>
          <td class="c-table-container__table__cell" mat-cell *matCellDef="let fechamento">
            {{fechamento.medidorAtualColorLeitura ||
            "Sem dados"}} </td>
        </ng-container>
        <ng-container matColumnDef="producaoColor">
          <th class="u-padding-horizontal-0" mat-header-cell *matHeaderCellDef>
            <div class="c-table-container__table__header-text">Produção color</div>
          </th>
          <td class="c-table-container__table__cell" mat-cell *matCellDef="let fechamento">
            {{fechamento.totalCopiasColorLeitura ||
            "Sem dados"}} </td>
        </ng-container>
        <tr class="c-table-container__table__header-row" mat-header-row
          *matHeaderRowDef="colunasVisiveis; sticky: true">
        </tr>
        <tr mat-row *matRowDef="let row; columns: colunasVisiveis;"></tr>
      </table>
    </div>
    <app-paginacao nomeDaLista="equipamentos" [(dados)]="fechamentos"
      (dadosChange)="obterFechamentos()"></app-paginacao>
  </ng-container>
</app-page-container>
<app-modal-general #modalSucesso [titulo]="'Download'" [botao]="'Fechar'" [mensagem]="'Download realizado com sucesso!'"
  (cliqueBotao)="fecharModal()"></app-modal-general>
<app-relatorio-exibido class="conteudo__relatorio"></app-relatorio-exibido>
<ng-template #listagemVaziaRef>
  <app-listagem-vazia></app-listagem-vazia>
</ng-template>